import {Component, Input, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError, finalize, switchMap, tap} from 'rxjs/operators';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicationService} from '../../services/application.service';
import {of} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';
import {DynamicInputComponent} from '@shared/dynamic-input/dynamic-input.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        FormsModule,
        NgIf,
        DynamicInputComponent,
        NgForOf
    ]
})
export class LoginComponent implements OnInit {
  @Input() type: string;
  @Input() idFieldLabel: string;
  @Input() resume: boolean;
  @Input() additionalFields: string[];
  @Input() additionalFieldsMeta: any;
  email!: string;
  email_submitted = false;
  access_key!: string;
  permit_id!: string;
  reporting_year!: string;
  submitting = false;
  additionalFieldValues: any = {};
  error: string | null = null;
  constructor(public http: HttpClient, private activeModal: NgbActiveModal,
              public applicationService: ApplicationService) {
  }

  ngOnInit(): void {
  }

  requestKey() {
    this.submitting = true;
    this.http.post(
      `${environment.baseUrl}/applications/auth/request_key/`,
      {email_address: this.email}
    ).pipe(
      tap(() => this.email_submitted = true),
      finalize(() => this.submitting = false)
    ).subscribe();
  }

  start() {
    document.cookie = 'permittingtoken=; Max-Age=-99999999;';
    this.error = null;
    this.applicationService.loadApplication(this.type, this.resume, {
      number: this.permit_id,
      token: this.access_key,
      email_address: this.email,
      ...this.additionalFieldValues
    }).pipe(
      tap(() => this.activeModal.close()),
      catchError(err => {
        this.error = err.error?.details;
        return of();
      })
    ).subscribe()
  }

  cancel() {
    this.activeModal.close();
  }
}
